// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__1MaCl","bigColWidth":"Table_bigColWidth__G3MjU","biggerColWidth":"Table_biggerColWidth__3Awa3","row":"Table_row__UMCu-","col":"Table_col__268CG"};